
<script>
import { Line, Bar } from "vue-chartjs";

export default {
  // Lineを先にするとバグる
  extends: Bar,
  Line,
  name: "LineBar",
  mounted() {
    this.addPlugin({
      beforeDraw: function (chart) {
        var ctx = chart.chart.ctx;
        var chartArea = chart.chartArea;
        ctx.fillStyle = "#fff";
        ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

        ctx.save();
        // ctx.restore();
      }


    });        
    this.renderChart(
      {
        labels: [
          "外向性",
          "協調性",
          "良識性",
          "情動性",
          "開放性",
          "論理思考",
          "構造思考",
          "感性思考",
          "直感思考",
          "主導型",
          "社交型",
          "安定性",
          "慎重型",
          "専門性・機能性",
          "全般管理",
          "自立・独立",
          "安全・安定",
          "起業家的想像力",
          "奉仕・社会貢献",
          "純粋な挑戦",
          "ライフスタイル",
        ].map((v) => v.split("")),

        datasets: [
          {
            type: "bar",
            //label: 'apples',
            backgroundColor: [
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(137,75,234,1)",
              "rgba(137,75,234,1)",
              "rgba(137,75,234,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
              "rgba(125,125,125,1)",
            ],
            data: [
              16.6,
              6.7,
              9.0,
              12.9,
              1.2,
              6.8,
              20.4,
              9.3,
              18.6,
              21.0,
              23.0,
              23.4,
              20.0,
              14.9,
              0.7,
              15.5,
              10.0,
              6.5,
              0.4,
              12.4,
              4.3,
            ],
            datalabels: {
              formatter: function () {
                return "";
              },
            },
          },
          {
            type: "line",
            // label: ' red-line',
            backgroundColor: "rgba(0,0,0,0)",
            borderColor: "#f09",
            data: [
              59.7,
              46.1,
              55.3,
              42.5,
              49.3,
              46.0,
              38.1,
              55.4,
              60.8,
              62.2,
              63.4,
              36.4,
              38.3,
              58.7,
              49.6,
              59.1,
              44.2,
              53.8,
              49.8,
              57.2,
              52.5,
            ],
            lineTension: 0,
            datalabels: {
              formatter: function () {
                return "";
              },
            },
          },
          {
            type: "line",
            // label: 'blue-line',
            backgroundColor: "rgba(0,0,0,0)",
            borderColor: "#05f",
            data: [
              43.1,
              52.8,
              46.2,
              55.4,
              50.5,
              52.8,
              58.5,
              46.1,
              42.3,
              41.2,
              40.4,
              59.7,
              58.4,
              43.8,
              50.3,
              43.5,
              54.1,
              47.3,
              50.2,
              44.8,
              48.2,
            ],
            lineTension: 0,
            datalabels: {
              formatter: function () {
                return "";
              },
            },
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          enabled:false
        },
        scales: {
          //軸設定
          yAxes: [
            {
              //y軸設定
              display: true, //表示設定
              // scaleLabel: {              //軸ラベル設定
              //   display: true,          //表示設定
              //   labelString: '縦軸ラベル',  //ラベル
              //   fontSize: 18               //フォントサイズ
              // },
              ticks: {
                //最大値最小値設定
                min: 0, //最小値
                max: 70, //最大値
                fontSize: 10, //フォントサイズ
                stepSize: 10, //軸間隔
              },
            },
          ],

          xAxes: [
            {
              //x軸設定
              display: true, //表示設定
              barPercentage: 0.7, //棒グラフ幅
              categoryPercentage: 0.7, //棒グラフ幅
              scaleLabel: {
                //軸ラベル設定
                display: false, //表示設定
                labelString: "High Performer", //ラベル
                fontSize: 16, //フォントサイズ
              },
              ticks: {
                fontSize: 11, //フォントサイズ
                fontColor: "#000"
              },
              gridLines: {
                color: "#ccc",
              },
            },
          ],
        },
      }
    );
    //console.log(this);
  },
};
</script>